(() => {
  const initLensSection = (section) => {
    if (!section || section.dataset.lensReady === 'true') return;
    section.dataset.lensReady = 'true';

    const track = section.querySelector('.lens-section__videos');
    const nextButton = section.querySelector('.lens-section__next');
    const cards = [...section.querySelectorAll('.lens-video')];
    const videos = [...section.querySelectorAll('.lens-video video')];
    if (!track || !cards.length) return;

    let activeIndex = Math.floor(cards.length / 2);
    let pointerStart = null;

    const render = () => {
      cards.forEach((card, index) => {
        const half = Math.floor(cards.length / 2);
        let offset = index - activeIndex;
        if (offset > half) offset -= cards.length;
        if (offset < -half) offset += cards.length;
        card.style.setProperty('--offset', offset);
        card.style.setProperty('--distance', Math.abs(offset));
        card.classList.toggle('is-active', index === activeIndex);
        card.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        card.setAttribute('aria-label', `Show video ${index + 1} of ${cards.length}`);

        const video = card.querySelector('video');
        if (!video) return;
        if (index === activeIndex) video.play().catch(() => {});
        else video.pause();
      });
    };

    const goTo = (index) => {
      activeIndex = (index + cards.length) % cards.length;
      render();
    };

    cards.forEach((card, index) => card.addEventListener('click', () => goTo(index)));

    nextButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      goTo(activeIndex + 1);
    });

    nextButton?.addEventListener('pointerdown', (event) => {
      event.stopPropagation();
    });

    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(activeIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(activeIndex + 1); }
    });

    track.addEventListener('pointerdown', (event) => {
      if (event.target.closest('button, a')) return;
      pointerStart = event.clientX;
      track.setPointerCapture?.(event.pointerId);
    });

    track.addEventListener('pointerup', (event) => {
      if (pointerStart === null) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) < 35) return;
      goTo(activeIndex + (distance < 0 ? 1 : -1));
    });

    track.addEventListener('pointercancel', () => { pointerStart = null; });
    render();

    videos.forEach((video) => {
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('aria-label', 'Community bird video');

    });

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting && video.closest('.lens-video')?.classList.contains('is-active')) video.play().catch(() => {});
        else video.pause();
      });
    }, { threshold: 0.2 });

    videos.forEach((video) => observer.observe(video));
  };

  document.querySelectorAll('[id^="SeenThroughLens-"]').forEach(initLensSection);

  document.addEventListener('shopify:section:load', (event) => {
    initLensSection(event.target.querySelector('[id^="SeenThroughLens-"]'));
  });
})();
